import { FC, ReactNode } from 'react';

import type { ResultColor } from './model';

type TileResultProps = Readonly<{
  color: ResultColor;
  solveModeLabel: ReactNode;
  subHeader?: ReactNode;
  price?: ReactNode;
  statusPanel?: ReactNode;
  progressBar?: ReactNode;
}>;

export const ResultPanel: FC<TileResultProps> = ({
  solveModeLabel,
  color,
  price,
  subHeader,
  progressBar,
  statusPanel,
}) => {
  return (
    <>
      <div className={`w-100 h-100 text-${color} bg-${color} bg-opacity-10 d-flex flex-column mt-2`}>
        <div className="d-flex mx-3 mt-3 justify-content-between align-items-center">
          {solveModeLabel}
          {subHeader}
        </div>
        <div className="flex-grow-1 px-3 d-flex flex-column justify-content-end mb-3">{price}</div>
        {statusPanel}
      </div>
      {progressBar}
    </>
  );
};

ResultPanel.displayName = 'ResultPanel';
